(() => {
  const dialog = document.querySelector('[data-safety-dialog]');
  if (!dialog || dialog.dataset.safetyControllerInitialized === 'true') return;
  const buyBox = document.getElementById('buybox');
  dialog.dataset.safetyControllerInitialized = 'true';

  const content = dialog.querySelector('[data-safety-content]');
  const live = dialog.querySelector('[data-safety-live]');
  const categoryTitle = dialog.querySelector('[data-safety-category-title]');
  const situations = dialog.querySelector('[data-safety-situations]');
  const answerActions = dialog.querySelector('[data-safety-answer-actions]');
  const views = [...dialog.querySelectorAll('[data-safety-view]')];
  const answers = [...dialog.querySelectorAll('[data-safety-answer]')];
  const triggers = [...document.querySelectorAll('[data-safety-open], [data-open-safety-center]')];
  const contactStatus = document.querySelector('[data-security-contact-status]');
  const popupContactStatus = dialog.querySelector('[data-safety-popup-contact-status]');
  const categories = {
    dermaplay_precautions: { label: 'Centro de Seguridad · DermaPlay', situations: [
      ['pregnancy', 'Embarazo y lactancia'],
      ['wheat-gluten', 'Alergia al trigo o intolerancia al gluten'],
      ['oncology', 'Antecedente oncológico reciente o cáncer activo'],
    ] },
  };
  let opener = null;
  let activeCategory = null;
  let bodyState = null;

  const focusable = () => [...dialog.querySelectorAll('a[href], button:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"])')]
    .filter((element) => !element.closest('[hidden], [inert]') && element.getClientRects().length);

  const announce = (message) => {
    live.textContent = '';
    window.requestAnimationFrame(() => { live.textContent = message; });
  };

  const showView = (name) => {
    views.forEach((view) => { view.hidden = view.dataset.safetyView !== name; });
    if (name !== 'answer') answers.forEach((answer) => { answer.hidden = true; });
    content.scrollTop = 0;
  };

  const showCategories = () => {
    activeCategory = null;
    showView('categories');
    announce('Categorías de seguridad disponibles.');
    dialog.querySelector('[data-safety-category]')?.focus();
  };

  const showSituations = (category) => {
    activeCategory = category;
    const data = categories[category];
    categoryTitle.textContent = data.label;
    situations.replaceChildren(...data.situations.map(([id, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.safetySituation = id;
      button.textContent = label;
      return button;
    }));
    showView('situations');
    announce(`${data.label}. Elige una situación.`);
    situations.querySelector('button')?.focus();
  };

  const actionButton = (label, action, primary = false) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `menoplay-pdp-button ${primary ? 'menoplay-pdp-button--primary' : 'menoplay-pdp-button--secondary'}`;
    button.dataset.safetyAction = action;
    button.textContent = label;
    return button;
  };

  const showAnswer = (id) => {
    const answer = answers.find((entry) => entry.dataset.safetyAnswer === id);
    if (!answer) return;
    answers.forEach((entry) => { entry.hidden = entry !== answer; });
    answerActions.replaceChildren();
    popupContactStatus.hidden = true;
    popupContactStatus.textContent = '';
    const isContinue = answer.dataset.safetyLevel === '1' || answer.dataset.safetyContinue === 'true';
    if (isContinue) {
      answerActions.append(actionButton('Continuar con mi compra', 'continue', true), actionButton('Revisar otra situación', 'situations'));
    } else {
      answerActions.append(actionButton('Hablar con el equipo de Eusari', 'contact', true), actionButton('Volver a mi modalidad', 'continue'));
    }
    answerActions.hidden = false;
    showView('answer');
    content.scrollTop = 0;
    announce(`${answer.querySelector('h3').textContent}. ${answer.querySelector('.menoplay-pdp-safety-center__status').textContent.trim()}`);
    dialog.querySelector('[data-safety-back="situations"]')?.focus();
  };

  const lockPage = () => {
    bodyState = {
      bodyOverflow: document.body.style.overflow,
      bodyOverscroll: document.body.style.overscrollBehavior,
      bodyPaddingRight: document.body.style.paddingRight,
      rootOverflow: document.documentElement.style.overflow,
    };
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';
    if (scrollbar > 0) document.body.style.paddingRight = `${scrollbar}px`;
    document.documentElement.style.overflow = 'hidden';
  };

  const unlockPage = () => {
    if (!bodyState) return;
    document.body.style.overflow = bodyState.bodyOverflow;
    document.body.style.overscrollBehavior = bodyState.bodyOverscroll;
    document.body.style.paddingRight = bodyState.bodyPaddingRight;
    document.documentElement.style.overflow = bodyState.rootOverflow;
    bodyState = null;
  };

  const close = ({ returnToBuyBox = false, restoreFocus = true } = {}) => {
    dialog.classList.remove('menoplay-pdp-is-active', 'menoplay-pdp-safety-center--expanded');
    const expandButton = dialog.querySelector('[data-safety-expand]');
    expandButton?.setAttribute('aria-expanded', 'false');
    if (expandButton) expandButton.textContent = 'Expandir panel';
    dialog.hidden = true;
    dialog.inert = true;
    dialog.setAttribute('aria-hidden', 'true');
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    unlockPage();
    if (returnToBuyBox && buyBox) {
      buyBox.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      buyBox.focus({ preventScroll: true });
    } else if (restoreFocus && opener?.isConnected) {
      opener.focus();
    }
  };

  const open = (trigger) => {
    document.dispatchEvent(new CustomEvent('menoplay:pdp:close-overlays', {
      detail: { except: 'safety' },
    }));
    opener = trigger;
    dialog.hidden = false;
    dialog.inert = false;
    dialog.setAttribute('aria-hidden', 'false');
    dialog.classList.add('menoplay-pdp-is-active');
    triggers.forEach((item) => item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false'));
    lockPage();
    showCategories();
    window.requestAnimationFrame(() => dialog.querySelector('[data-safety-close]')?.focus());
  };

  const openInbox = () => {
    const detail = { context: 'security_pre_purchase', source: 'dermaplay-pdp-safety' };
    document.dispatchEvent(new CustomEvent('eusari:security-contact', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('shopify:inbox:open', { bubbles: true, detail }));
    const chat = window.Shopify?.Chat || window.Shopify?.chat || window.Shopify?.Inbox || window.Shopify?.inbox;
    const method = chat?.open || chat?.show || chat?.toggle;
    if (typeof method === 'function') {
      method.call(chat, detail);
      return true;
    }
    return false;
  };

  const contact = () => {
    if (openInbox()) return;
    const message = 'El chat no está disponible en este momento. Conservamos tu selección de compra; inténtalo de nuevo más tarde.';
    if (contactStatus) {
      contactStatus.hidden = false;
      contactStatus.textContent = message;
    }
    if (popupContactStatus) {
      popupContactStatus.hidden = false;
      popupContactStatus.textContent = message;
    }
    announce(message);
  };

  triggers.forEach((trigger) => {
    trigger.hidden = false;
    trigger.inert = false;
    trigger.disabled = false;
    trigger.addEventListener('click', () => open(trigger));
  });

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.matches('[data-security-contact]')) contact();
    if (target.matches('[data-safety-close]')) close();
    if (target.matches('[data-safety-expand]')) {
      const expanded = dialog.classList.toggle('menoplay-pdp-safety-center--expanded');
      target.setAttribute('aria-expanded', String(expanded));
      target.textContent = expanded ? 'Reducir panel' : 'Expandir panel';
    }
    if (target.matches('[data-safety-category]')) showSituations(target.dataset.safetyCategory);
    if (target.matches('[data-safety-situation]')) showAnswer(target.dataset.safetySituation);
    if (target.matches('[data-safety-back="categories"]')) showCategories();
    if (target.matches('[data-safety-back="situations"]') && activeCategory) showSituations(activeCategory);
    if (target.matches('[data-safety-action="situations"]') && activeCategory) showSituations(activeCategory);
    if (target.matches('[data-safety-action="continue"]')) close({ returnToBuyBox: true });
    if (target.matches('[data-safety-action="contact"]')) contact();
  });

  document.addEventListener('menoplay:pdp:close-overlays', (event) => {
    if (event.detail?.except !== 'safety' && !dialog.hidden) close({ restoreFocus: false });
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  document.addEventListener('keydown', (event) => {
    if (dialog.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusable();
    const first = items[0];
    const last = items.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();